<template>
<div v-loading="loading" element-loading-text="Please don't leave the page! It is Submitting" style="overflow-x: hidden;">
    <div class="center fs18" style="padding-top: 40px;">
        <p class="black fs32 fw500">{{ $t('interviewTitle') }}</p>
        <span class="backyel dib divide"></span>
    </div>
    <div v-loading="isLoading" :class="$style.sbody" >
        <!-- <div class="dflex fw">
            <interviewCard v-for="item in list" :key="item.code" :item="item" :class="$style.item"></interviewCard>
        </div> -->
		<div class="right showInLargeb" style="margin-bottom: 50px;">
			<el-checkbox
			  v-if="list.length > 0"
			  v-model="isAllSelect"
			  @change="reverseSelection"
			  style="margin-right: 1.25rem;">{{ $t("selectAll") }}</el-checkbox>
		    <span style="margin-right: 20px;">{{ $t("interview12") + "：" + selectList.length }}</span>
		    <el-button  type="warning"  round @click="checkSelect">{{ $t('interview13') }}</el-button>	
		</div>
		<div class="showInSmall">
		    <div class="center" style="padding-bottom: 20px;">
				<el-checkbox
				  v-if="list.length > 0"
				  v-model="isAllSelect"
				  @change="reverseSelection"
				  style="margin-right: 1.25rem;">{{ $t("selectAll") }}</el-checkbox>
		        <span style="margin-right: 20px;">{{ $t("interview12") + "：" + selectList.length }}</span>
		        <el-button  type="warning"  round @click="checkSelect">{{ $t('interview13') }}</el-button>
		    </div>
		</div>
        <el-checkbox-group v-model="selectList" class="dflex fw" :class="$style.interviewCardDiv">
            <interviewCard v-for="item in list" 
			:key="item.code" :item="item" 
			@setYoutubeVideoId="setVideoId"
			:class="$style.item"></interviewCard>
        </el-checkbox-group>
        
		
        <div class="center" style="margin:30px;" v-if="showPagination">
            <el-pagination
                layout="prev, pager, next"
                @current-change="onCurrentChange"
                :current-page.sync="page"
                :hide-on-single-page="true"
                :page-count="totalPage">
            </el-pagination>
        </div>
    </div>
	
	
	<el-dialog
	  :visible.sync="centerDialogVisible"
	  width="90%"
	  center>
		  <div slot="title" style="background-color: #222a33 !important;border-top-left-radius:15px;border-top-right-radius:15px">
			  <p class="white fs32 fw500">{{ $t('interview14') }}</p>
		  </div>
		  <el-row type="flex" justify="center" align="middle">
		    <el-col :span="7" :class="$style.myelcol">
				<span :class="$style.gridright">{{ $t('interview15')}}：</span>
			</el-col>
		    <el-col :span="17">
				<div>
					<el-input v-model="applyParam.name" :placeholder="$t('interSt1')"></el-input>
				</div>
			</el-col>
		  </el-row>
		  
		  <el-row type="flex" justify="center" align="middle">
		    <el-col :span="7" :class="$style.myelcol">
					<span :class="$style.gridright">{{ $t('interview16')}}：</span>
			</el-col>
		    <el-col :span="17">
					<div>
						<el-select v-model="applyParam.gender" :placeholder="$t('interSt2')" :popper-class="$style.mySelect" :popper-append-to-body="false" clearable>
							<el-option
							v-for="item in genderOptions"
							:key="item.key"
							:label="item.label"
							:value="item.value">
							</el-option>
						</el-select>
					</div>
			</el-col>
		  </el-row>
		  
		  <el-row type="flex" justify="center" align="middle">
		    <el-col :span="7" :class="$style.myelcol">
		  				<span :class="$style.gridright">{{ $t('interview17')}}：</span>
			</el-col>
		    <el-col :span="17">
		  				<div>
		  					<el-input v-model="applyParam.mobile" :placeholder="$t('interSt3')" ></el-input>
		  				</div>
		  			</el-col>
		  </el-row>
		  
		  <el-row type="flex" justify="center" align="middle">
		    <el-col :span="7" :class="$style.myelcol">
		  				<span :class="$style.gridright">{{ $t('interview18')}}：</span>
			</el-col>
		    <el-col :span="17">
		  				<div>
		  					<el-input v-model="applyParam.email" ></el-input>
		  				</div>
		  			</el-col>
		  </el-row>
		  <el-row type="flex" justify="center" align="middle">
		    <el-col :span="7" :class="$style.myelcol">
		  				<span :class="$style.gridright">{{ $t('interview19')}}：</span>
			</el-col>
		    <el-col :span="17">
		  				<div class="">
		  					<el-date-picker
								v-model="applyParam.date"
								type="date"
								placeholder="please select date"
								:popper-class="$style.mydate"
								class="date"
								value-format="yyyy-MM-dd"
								:picker-options="forbiddenStartTime"
								>
							</el-date-picker>
							<el-time-select
								v-model="applyParam.time"
								style="width: 100%;"
								class="date"
								:picker-options="{
									start:'11:00',
									step:'00:30',
									end:'21:00'
								}"
								placeholder="please select time"
								:popper-class="$style.mydatetime"
							>
							</el-time-select>
		  				</div>
		  			</el-col>
		  </el-row>
		  
		  <span slot="footer" class="dialog-footer">
			<el-button @click="centerDialogVisible = false">{{ $t('cancel')}}</el-button>
			<el-button type="primary" @click="submit" :disabled="canSubmit" >{{ $t('confirm') }}</el-button>
		  </span>
	</el-dialog>
	
	<el-dialog
	  :visible.sync="resetInterviewAtDialogVisible"
	  :width="resetDialogWidth"
	  center>
		  <div slot="title" style="background-color: #222a33 !important;border-top-left-radius:15px;border-top-right-radius:15px">
			  <p class="white fs32 fw500">{{ $t('interH9') }}</p>
		  </div>
		  <el-row type="flex" justify="center" align="middle">
		    <el-col :span="7" :class="$style.myelcol">
					<span :class="$style.gridright">{{ $t('interH9')}}：</span>
			</el-col>
		    <el-col :span="17">
		  				<div class="">
		  					<el-date-picker
		  						v-model="resetDate"
		  						type="date"
		  						placeholder="please select date"
		  						:popper-class="$style.rmydate"
		  						class="date"
		  						value-format="yyyy-MM-dd"
								:picker-options="forbiddenStartTime"
		  						>
		  					</el-date-picker>
		  					<el-time-select
		  						v-model="resetTime"
		  						style="width: 100%;"
		  						class="date"
		  						:picker-options="{
		  							start:'11:00',
		  							step:'00:30',
		  							end:'21:00'
		  						}"
		  						placeholder="please select time"
		  						:popper-class="$style.rmydatetime"
		  					>
		  					</el-time-select>
		  				</div>
		  			</el-col>
		  </el-row>
		  
		  <span slot="footer" class="dialog-footer">
			<el-button @click="resetInterviewAtDialogVisible = false">{{ $t('cancel')}}</el-button>
			<el-button type="primary" @click="resetInterviewAt">{{ $t('confirm') }}</el-button>
		  </span>
	</el-dialog>
	
	<el-dialog
	  :visible.sync="submutSuccessDialogVisible"
	  :width="resetDialogWidth"
	  center>
		  <div slot="title" style="background-color: #222a33 !important;border-top-left-radius:15px;border-top-right-radius:15px">
				<p class="white fs32 fw500">{{ $t('success') }}</p>
		  </div>
		  <div class="center gray fs18">
		      <div class="left">
				<p class="mb30">{{ $t('interviewSubmitContent1') }}</p>
				<p class="mb30">{{ $t('interviewSubmitContent2') }}</p>
				<p class="mb30">{{ $t('interviewSubmitContent3') }}</p>
				<p class="mb30">{{ $t('interviewSubmitContent4') }}</p>
		      </div>
		  </div>
	 </el-dialog>
	
	<div class="center fs18" style="padding-top: 40px;">
	    <p class="black fs32 fw500">{{ $t('interviewH') }}</p>
	    <span class="backyel dib divide"></span>
	</div>
	<div :class="$style.sbody" v-loading = "historyIsLoading">
		<div class="dflex fw" :class="$style.interviewCardDiv">
			<iHCard v-for="item in hList" 
			:key="item.code" 
			:item="item" 
			@setYoutubeVideoId="setVideoId"
			:class="$style.item"></iHCard>
		</div>
		<div class="center"  v-if="hShowPagination">
		    <el-pagination
		        layout="prev, pager, next"
		        @current-change="onHCurrentChange"
		        :current-page.sync="hPage"
		        :hide-on-single-page="true"
		        :page-count="hTotalPage">
		    </el-pagination>
		</div>
		<playVideoDialogVue
			v-show="videoId != ''" 
			:dialogVisible="playVideoVisible" 
			@closePlayDialog="handleCancleYoutubePlay"
			:videoId="videoId"></playVideoDialogVue>
	</div>
</div>
</template>
<script>
import interviewCard from '../components/interviewCard.vue';
import iHCard from '../components/iHCard.vue';
import playVideoDialogVue from '../components/playVideoDialog.vue';

export default {
    name: 'Interviews',
	components:{
		interviewCard,
		iHCard,
		playVideoDialogVue,
	},
    data() {
        return {
			canSubmit: false,
			loading: false,
            isLoading: true,
            page:1,
            totalPage:1,
            showPagination: false,
            list: [],
            selectList: [],
			centerDialogVisible: false,
			resetInterviewAtDialogVisible: false,
			submutSuccessDialogVisible: false,
			applyParam:{
				name:"",
				gender:"",
				mobile:"",
				email:"",
				date:'',
				time:'',
			},
			genderOptions:[
				{key:1,label:'Mr.',value:'Mr.'},
				{key:2,label:'Ms.',value:'Ms.'},
				{key:3,label:'Mrs.',value:'Mrs.'}
			],
			dateOptions:{
				step: '00:30',
				
			},
			historyIsLoading: true,
			hPage:1,
			hTotalPage:1,
			hShowPagination: false,
			hList:[],
			resetDate:"",
			resetTime:"",
			resetItem:[],
			resetDialogWidth: document.body.clientWidth < 770 ? '90%' : '50%',
			forbiddenStartTime:{
				disabledDate:this.disabledDateMethod
			},
			isCanToday:false,
			isAllSelect:false,
			playVideoVisible:false,
			videoId: '',
        };
    },
    created() {
        this.loadlist();
        this.$top();
		this.loadingHistory();
    },
	watch:{
		page(){
			this.isAllSelect = false
		}
	},
    provide(){
        return {
            loadlist: this.loadlist,
			loadingHistory: this.loadingHistory,
			showResetDialog: this.showResetDialog,
        };
    },
    methods:{
		handleCancleYoutubePlay(){
			this.playVideoVisible = false;
			this.videoId = "";
		},
		setVideoId(videoId){
			this.playVideoVisible = true;
			this.videoId = videoId;
		},
		reverseSelection(){
			if(this.list.length == 0) return;
			const isSelect = this.isAllSelect
			if(this.isAllSelect){
				this.list.forEach(v => {
					if(this.selectList.indexOf(v.code) == -1){
						this.selectList.push(v.code);
					}
				})
			}else{
				this.list.forEach(v => {
					let index = this.selectList.indexOf(v.code);
					if(index != -1){
						this.selectList.splice(index,1);
					}
				})
			}
			this.list.forEach(v => {
				v.isSelect = isSelect
			})
		},
		disabledDateMethod(time){
			if (this.isCanToday) {
				return time.getTime() < Date.now() - 86400000;
			}
			return time.getTime() < Date.now();
		},
		resetInterviewAt(){
			if(this.resetItem.length == 0) return;
			const params = {
				id:this.resetItem.id,
				a_id:this.resetItem.a_id,
				interview_date:this.resetDate,
				interview_time:this.resetTime,
			};
			this.$service.resetInterviewAt(params).then((res)=>{
				this.resetInterviewAtDialogVisible = false;
				this.$message.success("Reset Success");
				this.loadingHistory();
			}).catch((res)=>{
				this.$message({
				  message: res.message || 'Something Error',
				  type: 'error',
				  offset: 350,
				});
			})
		},
		showResetDialog(params){
			this.resetInterviewAtDialogVisible = true;
			this.resetItem = params;
		},   
        loadlist() {
            this.isLoading = true;
            const params = {
                page: ''+this.page,
            };
            this.$service.getInterviewsList(params).then((data) => {
                this.list = data.list;
                this.totalPage = data.page_num;
				this.isCanToday = data.isCanToday
                this.showPagination = true;
                this.isLoading = false;
            })
        },
		loadingHistory() {
			this.historyIsLoading = true;
			const params = {
				page: ''+this.hPage,
				lang: this.$i18n.locale,
			};
			this.$service.getInterviewsHistoryList(params).then((data)=>{
				this.hList = data.list;
				this.hTotalPage = data.page_num;
				this.hShowPagination = true;
				this.historyIsLoading = false;
			});
		},
        onCurrentChange(e) {
            this.loadlist();
        },
		onHCurrentChange(e) {
		    this.loadingHistory();
		},
		checkSelect(){
			if(this.selectList.length == 0){
				this.$message({
					  message: 'Please Select Helper',
					  type: 'warning',
					  offset: 350,
				});
				return
			}
			this.centerDialogVisible = true
			this.$service.getInterviewApplyHistoryForm().then((data)=>{
				if(data.length != 0) {
					this.applyParam.name = data.name;
					this.applyParam.gender = data.gender;
					this.applyParam.mobile = data.mobile;
					this.applyParam.email = data.email;
				}else{
					this.applyParam.name = '';
					this.applyParam.gender = '';
					this.applyParam.mobile = '';
					this.applyParam.email = '';
				}
			});
		},
		message(msg,type = 'error'){
			this.$message({
				  message: msg,
				  type: type,
				  offset: 350,
			});
		},
		checkSubmut(){
			if(!this.applyParam.name){
				this.message('Please enter name')
				return false
			}
			if(!this.applyParam.gender){
				this.message('Please enter gender')
				return false
			}
			if(!this.applyParam.mobile){
				this.message('Please enter mobile')
				return false
			}
			if(!this.applyParam.email){
				this.message('Please enter email')
				return false
			}
			if(!this.applyParam.date){
				this.message('Please enter date')
				return false
			}
			if(!this.applyParam.time){
				this.message('Please enter time')
				return false
			}
			return true
		},
		checkEmail(email){
			const regEmail = /^([a-zA-Z0-9_.-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
			if (regEmail.test(email)){
				return true;
			}
			return false;
		},
        submit(){
			this.loading = true;
			this.canSubmit = true;
			if(!this.checkSubmut()) {
				this.loading = false;
				this.canSubmit = false;
				return;
			}
			
			if(!this.checkEmail(this.applyParam.email)){
				this.$message({
					  message: 'Please enter the correct email address',
					  type: 'error',
					  offset: 350,
				});
				this.loading = false;
				this.canSubmit = false;
				return
			}
			this.applyParam.codeArr = this.selectList;
            this.$service.submitApplyInterview(this.applyParam).then((data)=>{
				this.centerDialogVisible = false;
				this.loadlist();
				this.loadingHistory();
				this.loading = false;
				this.submutSuccessDialogVisible = true;
			}).catch((res = {}) => {
				this.$message({
				  message: res.message || 'Submission failed',
				  type: 'error',
				  offset: 350,
				});
				this.loading = false;
				this.canSubmit = false;
			});
        },
    },
}
</script>
<style module>
.interviewCardDiv{
	justify-content: space-between;
}
.myelcol{
	text-align: right;
	padding-right: 60px;
}
.mydatetime{
	top: 610px !important;
}
.mydate{
	top: 430px !important;
	left: 590px !important;
}
.rmydatetime{
	top: 315px !important;
}
.rmydate{
	top: 260px !important;
	left: 515px !important;
}
.mySelect{
	position: absolute !important;
	top: 30px !important;
	left: 0px !important;
}
.gridright {
  height: 5rem;
  text-align: right;
  line-height: 4rem;
  font-size: 1rem;
}
.btn {
    padding: 0px 23px;
    line-height: 2;
    cursor: pointer;
    display: inline-block;
}
.btn:hover {
    background: #ffd250e6;
}
.btn[disabled], .btn[disabled]:hover {
    background: #aaaaaa70;
    color: #222a33;
    cursor: not-allowed;
}
.card {
    width: 45%;
    margin-right: 50px;
    margin-bottom: 60px;
}
.sbody {
    margin: 0 140px 20px 140px;
}
.item {
    margin-bottom: 60px;
    width:50%;
}
@media screen and (max-width: 770px) {
	.myelcol{
		text-align: right;
		padding-right: 0;
	}
    .sbody {
        margin: 20px 10px;
    }
    .item {
        width: 100%;
        margin-bottom: 20px;
    }
	.mydatetime{
		top: 568px !important;
	}
	.mydate{
		top: 180px !important;
		left: 30px !important;
		width: 100%;
	}
	.rmydatetime{
		top: 270px !important;
	}
	.rmydate{
		top: 225px !important;
		left: 30px !important;
		width: 100%;
	}
}
</style>
